import React from 'react';
import { useDispatch } from 'react-redux';
import SharedRefreshButton from 'shared/ui/RefreshButton';
import { getData } from 'Screens/Contextualization/KnowledgeBase/actions/Actions';

const RefreshButton = () => {
  const dispatch = useDispatch();

  const handleClick = () => (dispatch(getData()));

  return (
    <SharedRefreshButton onClick={ handleClick } dataTestId="kb-refresh-button" />
  );
};

export default RefreshButton;
